import posthog from 'posthog-js';

const POSTHOG_KEY = 'phc_wH6K2YdXd9CUgzjiwbLgegJySwSx5c8qujWogNtjVW8V';
const POSTHOG_HOST = 'https://us.i.posthog.com';

posthog.init(POSTHOG_KEY, {
  api_host: POSTHOG_HOST,
  autocapture: true,          // Captures clicks, form submissions, page views automatically
  capture_pageview: true,     // Tracks every page load
  capture_pageleave: true,    // Tracks session duration
  persistence: 'localStorage',
});

/**
 * Track when a user clicks a product link.
 * @param {string} category - e.g. "AI", "Worship"
 * @param {string} subcategory - e.g. "AI Writing Tools"
 * @param {string} productName - e.g. "ChatGPT"
 * @param {string} productUrl - e.g. "https://chat.openai.com"
 */
export const trackProductClick = (category, subcategory, productName, productUrl) => {
  posthog.capture('product_clicked', {
    category,
    subcategory,
    product_name: productName,
    product_url: productUrl,
  });
};

export default posthog;
